import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
    return (
        <header className="header">
            <div className="header-container">
                <h1 className="logo">EasyDreams</h1>
                <nav className="nav">
                    <ul className="nav-links">
                        <li>
                            <Link to="/" className="nav-link">
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy-policy" className="nav-link">
                                Privacy Policy
                            </Link>
                        </li>
                        <li>
                            <Link to="/terms" className="nav-link">
                                Terms & Conditions
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default Header;